<template>
  <div :style="{ width: width + 'px', height: height + 'px' }">
    <div v-if="design" class="activeMask" />
    <div style="width: 100%;height: 100%" :id="uuid" @contextmenu.prevent />
  </div>
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { getCodeByName, registerMap, transferGeoJSON } from "@/utils/map-manage";
import 'echarts-gl';
import { onMounted, watch, computed} from "vue";
import * as echarts from 'echarts'
// import chinaGeoJson from '@/assets/map/china.json'
const loadChinaGeoJson = async () => {
     const { default: chinaGeoJson } = await import('@/assets/map/china.json');
     return chinaGeoJson;
   };

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  design: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
watch(() => props.option.attribute, (obj) => {
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})


let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let lastCityCode = '';//地图下钻记录上一级
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  // echarts.registerMap('china', chinaGeoJson);
  // let element = document.getElementById(uuid)
  // if (!element) {
  //   return
  // }
  // chart = echarts.init(element)
  // refreshCptData(props.option.cptDataForm)

  loadChinaGeoJson().then(chinaJson => {
    echarts.registerMap('china', chinaJson);
    let element = document.getElementById(uuid)
    if (!element) {
      return
    }
    chart = echarts.init(element)
    if (dataReload.value.includes(0)) {
      refreshCptData();
    }
  });
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        let newarr = [];
        // 遍历原始数组并重组数据
        res.forEach(item => {
          let name = item[dataKey[0].value];
          let value = item[dataKey[1].value];

          // 创建新的对象并添加到 aa 数组中
          newarr.push({ name, value });
        });
        console.log(newarr, '新数组')
        cptData = newarr;
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;
  }
}
function loadChart(attribute) {
  chart.clear();
  registerMap(attribute.provinceCode, attribute.cityCode).then(cityCode => {
    const geoJSON = echarts.getMap(cityCode).geoJSON.features;
    const barData = transferGeoJSON(cptData, geoJSON);
    chartOption = {
      title: attribute.title,
      tooltip: {
        formatter: function (param) {
          return param.data.name + ': ' + (param.data.value[2] || param.data.value)
        }
      },
      geo3D: {
        show: false,
        map: cityCode,
        boxHeight: 30,
        viewControl: {
          rotateSensitivity: 6,//旋转操作的灵敏度
          minBeta: -180,
          maxBeta: 180,
          minAlpha: -180,
          maxAlpha: 180,
        },
        /*shading: 'lambert',
        itemStyle: attribute.itemStyle,
        label: attribute.label,
        light: {
          main: {
            color: '#ffffff',
            shadow: false,
          },
        },*/
      },
      //直接用geo3d作为地图时，鼠标放置在地图上会console警告信息，所以在series中又定义了一个地图，geo3D不显示
      series: [
        {
          name: attribute.seriesName,
          type: 'map3D',
          boxHeight: 30,
          data: cptData,
          map: cityCode,
          viewControl: {
            rotateSensitivity: 6,
            minBeta: -180,
            maxBeta: 180,
            minAlpha: -180,
            maxAlpha: 180,
          },
          shading: 'lambert',
          itemStyle: attribute.itemStyle,
          label: attribute.label,
          light: {
            main: {
              color: '#ffffff',
              shadow: false,
            }
          }
        },
        {
          name: attribute.seriesName,
          type: 'bar3D',
          coordinateSystem: 'geo3D',
          itemStyle: { color: attribute.barColor },
          minHeight: 0.2,
          barSize: attribute.barSize,
          data: barData,
          zlevel: 10,
        }
      ],
    }
    chart.setOption(chartOption, true);
    chart.on("click", function (params) {
      console.log(params);
    });
  })
}
function drillDown() {
  chart.on('click', function (params) {//点击下钻
    emit("clickHandler", props.option.interaction, 'default', params.name)//组件交互
    if (props.option.attribute.enableDrillDown) {
      let code = getCodeByName(params.name, chartOption.geo.map);
      if (code != null) {
        chart.clear()
        registerMap(code).then(cityCode => {
          lastCityCode = chartOption.geo.map;//记录下钻前的code
          chartOption.geo.map = cityCode;
          chart.setOption(chartOption);
        })
      }
    }
  });
  if (props.option.attribute.enableDrillDown) {
    chart.on('contextmenu', () => {
      let code = lastCityCode
      if (!lastCityCode) {
        code = props.option.attribute.provinceCode
      }
      if (chartOption.geo.map !== 'china') {
        chart.clear();
        if (chartOption.geo.map === code) {
          code = 'china'
        }
        registerMap(code).then(cityCode => {
          chartOption.geo.map = cityCode;
          chart.setOption(chartOption);
        })
      }
    })
  }
}

defineExpose({ refreshCptData })
</script>

<style scoped>
.activeMask {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 1801;
}
</style>
